// extracted by mini-css-extract-plugin
module.exports = {"center":"HelpModal_center__1HpEh"};